// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3XTo5","vLegacy":"SelectSecondary_vLegacy__kbP3P","error":"SelectSecondary_error__QMrAk","disabled":"SelectSecondary_disabled__1PfLR"};